<app-header></app-header>
@if(user){
<app-sidebar class="sidebar position-fixed left-0" [navigation]="navigation"></app-sidebar>
}

<div class="router-content">
  <div class="container-fluid">
    @if(rehabilitationInit.length) {
    <h3 class="text-secondary my-3">
      {{ 'rehabilitation_programs' | transloco }}
    </h3>

    <app-rehabilitation-order
      *ngFor="let program of rehabilitationInit"
      (formValue)="setProgramItem($event)"
      [programValue]="program"
      (delete)="onDelete($event)"
    >
    </app-rehabilitation-order>
    } @if(educationInit.length) {
    <h3 class="text-secondary my-3">{{ 'education_programs' | transloco }}</h3>

    <app-education-order
      *ngFor="let program of educationInit"
      (formValue)="setProgramItem($event)"
      [programValue]="program"
      (delete)="onDelete($event)"
    >
    </app-education-order>
    } @if(serviceInit.length) {
    <h3 class="text-secondary my-3">{{ 'services' | transloco }}</h3>

    <app-service-order
      *ngFor="let program of serviceInit"
      (formValue)="setProgramItem($event)"
      [programValue]="program"
      (delete)="onDelete($event)"
    ></app-service-order>
    } @if(!serviceInit.length && !rehabilitationInit.length && !educationInit.length) {
    <h3 class="text-primary">{{ 'empty' | transloco }}</h3>
    }@else { @if(user){
    <div class="programs-view-footer d-flex justify-content-center gap-2 text-center">
      @if(!goToFastPay){
      <button class="btn btn-primary w-50" [disabled]="!form.valid" (click)="checkout()">
        {{ 'checkout' | transloco }}
      </button>
      } @if(goToFastPay){
      <button class="btn btn-primary w-50" [disabled]="!form.valid" (click)="checkout()">
        {{ 'go_to_pay' | transloco }}
      </button>
      }
    </div>
    } @else {
    <div class="programs-view-footer d-flex justify-content-center gap-2 text-center">
      <span>
        {{ 'sign_in_to_continue' | transloco }}
        <a routerLink="/sign-in" class="link-primary cursor"> {{ 'sign_in' | transloco }}</a>
        {{ 'or' | transloco }}
        <a routerLink="/sign-up" class="link-primary cursor"> {{ 'sign_up' | transloco }}</a>
      </span>
    </div>
    } }
  </div>
</div>
